import { connect } from 'react-redux';

import CreateGroupSetDialog from './CreateGroupSetDialog';

import { operations, selectors } from '../../../../../store/groups';

const mapStateToProps = (state) => ({
  open: selectors.isCreateGroupSetDialogOpen(state),
  saving: selectors.isCreatingGroupSet(state),
});

const mapDispatchToProps = (dispatch) => ({
  onSave: (groupSet) => dispatch(operations.addGroupSet(groupSet)),
  onClose: () => dispatch(operations.closeAddGroupSet),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateGroupSetDialog);
